import { useEffect, useState } from 'react';
import useAppRefs from '@/hooks/useAppRefs';
import useLandingPageRefs from '@/components/landing-page/hooks/useLandingPageRefs';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';

export default function useStickySuccessBox(apply: boolean) {
  const { headerRef } = useAppRefs();
  const { mainRef, successBoxRef } = useLandingPageRefs(apply);
  const [appHeaderElement, setAppHeaderElement] = useState<HTMLDivElement | null>(null);
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  const getElementHeight = (element: HTMLDivElement): number =>
    element ? Math.round(element.getBoundingClientRect().height) : 0;

  useEffect(() => {
    if (cssVersion === 2) return;
    if (!appHeaderElement || !mainRef.current || !successBoxRef.current) return;
    const headerHeight = getElementHeight(appHeaderElement);
    const successBoxHeight = getElementHeight(successBoxRef.current);

    if (apply) {
      mainRef.current.style.setProperty('margin-top', `${successBoxHeight + headerHeight}px`);
      successBoxRef.current.style.setProperty('top', `${headerHeight}px`);
    } else {
      mainRef.current.removeAttribute('style');
      successBoxRef.current.removeAttribute('style');
    }
  }, [apply, appHeaderElement, mainRef, successBoxRef]);

  useEffect(() => {
    if (cssVersion === 2) return;
    if (headerRef && headerRef.current) setAppHeaderElement(headerRef.current);
  }, [headerRef]);
}
